module.exports = __webpack_public_path__ + "img/7.c72e99d5.png";